import React, { Component } from 'react';
import { AgGridReact } from 'ag-grid-react';
import { AllModules } from 'ag-grid-enterprise';
import "ag-grid-community/dist/styles/ag-grid.css";
import "ag-grid-community/dist/styles/ag-theme-material.css";
import 'ag-grid-enterprise';
import { Link } from 'react-router-dom';
import ClientCodeDropdown from '../dropdowns/clientCodeDropDown';
import BranchCodeDropdown from '../dropdowns/branchCodeDropDown';
import VehicleDropdown from '../dropdowns/vehicleDropDown';

import { LicenseManager } from 'ag-grid-enterprise';
import { Button, Icon, Input, Form as FormUi, Modal, Loader } from 'semantic-ui-react';
import { Formik, Field as Fieldmik } from 'formik';
import moment from 'moment';
import * as yup from 'yup';
import ImportModal from '../../views/importModal/importModal';
import { messages, validationMessages, dateFormats } from '../../utils/constant'
import { buttons } from './agGridConstants'

import { DateData } from '../formikInput/date';

import Axios from 'axios';
import APP_CONSTANT from '../../config/constants';
import CustomNoRowsOverlay from './customNoRowsOverlay';
import TitleBar from '../titleBar/titleBar';
import { last } from 'lodash';
import { data } from 'jquery';
import ActionButton from './actionButton';

import xlsx from "json-as-xlsx"

LicenseManager.setLicenseKey('Elixia_Tech_Solutions_Ltd_MultiApp_1Devs16_March_2019__MTU1MjY5NDQwMDAwMA==c4c29e5702e62789dbdb799433c73545')

class AgGridTable extends Component {
    constructor(props) {
        super(props);
        this.state = {
            modules: AllModules,
            defaultColDef: {
                flex: 1,
                minWidth: 100,
                enableValue: true,
                enableRowGroup: true,
                enablePivot: true,
                resizable: true,
            },
            selectedBranch: '',
            branchData: [],
            selectedClient: {},
            sideBar: {
                toolPanels: [
                    {
                        id: "columns",
                        labelDefault: 'Columns',
                        labelKey: 'columns',
                        iconKey: 'columns',
                        toolPanel: 'agColumnsToolPanel'
                    },
                    {
                        id: 'filters',
                        labelDefault: 'Filters',
                        labelKey: 'filters',
                        iconKey: 'filters',
                        toolPanel: 'agFiltersToolPanel'
                    },
                ],
                defaultToolPanel: '',
            },
            isLoading: true,
            rowData: [],
            frameworkComponents: {
                actionRenderer: props.actionButton || ActionButton,
                customNoRowsOverlay: CustomNoRowsOverlay,
                ...props.extraComponents
            },
            noRowsOverlayComponent: 'customNoRowsOverlay',
            noRowsOverlayComponentParams: {
                noRowsMessageFunc: function () {
                    return messages.NO_RECORDS_FOUND;
                },
            },
            ImportModalState: false,

            selectedClientChange: false,
            selectedBranchChange: false,
            selecteVehicleChange: false,
            searchChange: false,
            searchTerms: '',
            openLoader: false
        };
    };

    handleImportClose = () => {
        this.setState({ ImportModalState: false })
        window.location.reload();
    };

    handleImportOpen = () => {
        this.setState({ ImportModalState: true })
    };


    getParams() {
        return {
            columnGroups: true,
            fileName: this.props.titleBarTitle,
        };
    };

    onBtnExportDataAsExcel = () => {
        var params = this.getParams();
        this.gridApi.exportDataAsExcel(params);
    };

    importDataGrid = () => {
        //console.log("import the data grid"); //test why is it here
    };

    filterChanged = (e) => {
        if (this.gridApi.getDisplayedRowCount() === 0) {
            this.gridApi.showNoRowsOverlay();
        } else {
            this.gridApi.hideOverlay();
        };
    };

    onGridReady = (params) => {
        this.gridApi = params.api;

        this.setState({
            isLoading: this.props.isLoading,
        });

        this.gridColumnApi = params.columnApi;

        //AutoSize Columns OnGridReady
        var allColumnIds = [];

        this.gridColumnApi.getAllColumns().forEach(function (column) {
            allColumnIds.push(column.colId);
        });

        this.gridColumnApi.autoSizeColumns(allColumnIds);
    };

    exportDataGrid = (data) => {
        if (data) {
            let keys = []
            this.props.columnDefs.forEach(element => {
                element.field !== "edit" && keys.push(element.headerName)
            });

            let param = {
                fileName: this.props.titleBarTitle,
                allColumns: true,
            };

            this.gridApi.exportDataAsExcel(param);
        };
    };

    exportDataSalesOrder = async () => {
        this.setState({
            openLoader: true,
        });

        let headerData = {
            "api_token": localStorage.getItem('apiToken'),
            "customer_no": localStorage.getItem('customerNo'),
            "user_id": localStorage.getItem('userId'),
            'is_data_export': 1
        }

        const { data } = await Axios.post(`${APP_CONSTANT.BASE_URL}sales/sales-orders`, headerData, {
            headers: {
                'Content-Type': 'application/json',
                "Authorization": localStorage.getItem('apiToken'),
                "Access-Control-Allow-Origin": "*"
            }
        });

        if (data?.data) {
            let excelData = [
                {
                    sheet: "sales-orders",
                    columns: [
                        { label: "SO No", value: "so_number" },
                        { label: "SO Date", value: "so_date" },
                        { label: "Lr Number", value: "lr_no" },
                        { label: "Lr Date", value: "lr_date" },
                        { label: "Refrence No", value: "reference_number" },
                        { label: "Customer Name", value: "client_name" },
                        { label: "Amount", value: "so_amount" },
                        { label: "Branch", value: "branch_name" },
                        { label: "Vehicle", value: "vehicle_number" },
                        { label: "Remarks", value: "remarks" },
                        { label: "Created On", value: "created_at" },
                        { label: "Created By", value: "created_by_name" },
                        { label: "Modified On", value: "updated_at" },
                        { label: "Modified By", value: "updated_by_name" },
                    ],
                    content: data.data.map(({
                        so_number, so_date, lr_no, lr_date, reference_number, client_name,
                        so_amount, branch_name, vehicle_number, remarks, created_at, created_by_name, updated_at, updated_by_name
                    }) => {
                        return ({
                            so_number, so_date, lr_no, lr_date, reference_number, client_name,
                            so_amount, branch_name, vehicle_number, remarks, created_at, created_by_name, updated_at, updated_by_name

                        })
                    })
                },
            ]
            let settings = {
                fileName: this.props.titleBarTitle,
                writeMode: "writeFile",
            }

            const exportCallback = () => {
                this.setState({
                    openLoader: false,
                });
            }

            xlsx(excelData, settings, exportCallback)
        };
    };

    exportDataCustomerInvoice = async () => {
        this.setState({
            openLoader: true,
        });

        let headerData = {
            "api_token": localStorage.getItem('apiToken'),
            "customer_no": localStorage.getItem('customerNo'),
            "user_id": localStorage.getItem('userId'),
            'is_data_export': 1
        }

        const { data } = await Axios.post(`${APP_CONSTANT.BASE_URL}sales/sales-invoices`, headerData, {
            headers: {
                'Content-Type': 'application/json',
                "Authorization": localStorage.getItem('apiToken'),
                "Access-Control-Allow-Origin": "*"
            }
        });

        if (data?.data) {
            let excelData = [
                {
                    sheet: "customer-invoice",
                    columns: [
                        { label: "Customer Invoice No.", value: "invoice_no" },
                        { label: "Customer Invoice Date", value: "invoice_date" },
                        { label: "Reference No.", value: "reference_number" },
                        { label: "IRN Code", value: "irnCode" },
                        { label: "Integrated Reference Number", value: "integratedReferenceNumber" },
                        { label: "Customer Name", value: "client_name" },
                        { label: "Invoice Amount", value: "invoice_amt" },
                        { label: "Pending Amount", value: "pending_amt" },
                        { label: "Expected Payment Date", value: "expected_payment_date" },
                        { label: "Remarks", value: "remarks" },
                        { label: "Created On", value: "created_at" },
                        { label: "Created By", value: "created_by_name" },
                        { label: "Modified On", value: "updated_at" },
                        { label: "Modified By", value: "updated_by_name" },
                    ],
                    content: data.data.map(({
                        invoice_no, invoice_date, reference_number, irnCode, integratedReferenceNumber, client_name,
                        invoice_amt, pending_amt, expected_payment_date, remarks, created_at, created_by_name, updated_at, updated_by_name
                    }) => {
                        return ({
                            invoice_no, invoice_date, reference_number, irnCode, integratedReferenceNumber, client_name,
                            invoice_amt, pending_amt, expected_payment_date, remarks, created_at, created_by_name, updated_at, updated_by_name
                        })
                    })
                },
            ]
            let settings = {
                fileName: this.props.titleBarTitle,
                writeMode: "writeFile",
            }

            const exportCallback = () => {
                this.setState({
                    openLoader: false,
                });
            }

            xlsx(excelData, settings, exportCallback)
        };
    };

    handleSearch = (e) => {
        this.setState({
            searchChange: true,
            searchTerms: e.target.value,
        });
    };

    filterData = () => {
        const payload = {
            "client_code": this.state?.selectedClientChange ? this.state?.selectedClient?.billingPartyCode : this.props.ClientCode,
            "branch_code": this.state?.selectedBranchChange ? this.state?.selectedBranch : this.props.BranchCode,
            "vehicle_id": this.state?.selecteVehicleChange ? this.state?.selecteVehicle : this.props.VehicleCode,
            "search_value": this.state?.searchChange ? this.state?.searchTerms : this.props.searchValue
        }
        this.props.setFilterValues(payload)
    };

    currentDate = new Date()

   mymap = new Map();
     
    unique = this.props.uniqueRowData && this.props.uniqueRowData.filter(el => {
        const val = this.mymap.get(el.customerInvoiceNo);
        if (val) {
            if (el.id < val) {
                this.mymap.delete(el.customerInvoiceNo);
                this.mymap.set(el.customerInvoiceNo, el.refNo);
                return true;
            } else {
                return false;
            }
        }
        this.mymap.set(el.customerInvoiceNo, el.refNo);
        return true;
    });


    render() {
        const month = this.currentDate.getMonth();
        const year = this.currentDate.getFullYear();

        const firstDay = new Date(year, month, 1);

        const initialValues = {
            startDate: firstDay || '',
            endDate: this.currentDate || ''
        }

        const initialFilterValues = {
            // salesNumber: '',
            // salesDate: '',
            // lrNumber: '',
            // lrDate: '',
            // refNo: '',
            // customerName: ''
            searchString: ''
        }

        const validateSchema = yup.object().shape({
            startDate: yup.string().required(validationMessages.START_DATE_REQUIRED),
            endDate: yup.string().required(validationMessages.END_DATE_REQUIRED),
        })

        const onSubmit = (values) => {
            this.props.getFilterDates(values.startDate, values.endDate)
        }

        const onSubmitFilter = (values) => {
            this.props.getFilterSalesOrder(values)
        }

        return (
            <>
                <TitleBar approvals={this.props.approvalSection} title={this.props.titleBarTitle} hiddenNew={this.props.hiddenNew} LinkName={this.props.link} >

                    {this.props.approvalCountSection ?
                        this.props.removeStatus ?
                            ""
                            :
                            <div className="mr-4">
                                <Button.Group>
                                    <Button size='tiny' type='button' className="w3-tiny w3-border" basic color="light-grey" icon>{buttons.pending || "Pending"} {this.props.approvalData.pending}</Button>
                                    <Button size='tiny' type='button' className="w3-tiny   " basic color="green" icon>{buttons.approved || "Approved"} {this.props.approvalData.approved}</Button>
                                    {
                                        this.props.showReject == undefined || this.props.showReject == true ?
                                            <Button size='tiny' type='button' className="w3-tiny" basic color="red" icon>{buttons.rejected || "Rejected"}{this.props.approvalData.rejected}</Button>
                                            : null
                                    }
                                </Button.Group>
                            </div>
                        :
                        ""
                    }

                    {this.props.dateFilter ?
                        <>
                            <Formik
                                initialValues={initialValues}
                                validationSchema={validateSchema}
                                onSubmit={onSubmit}
                            >
                                {({ touched, isSubmitting, errors, values, handleSubmit, form }) => (
                                    <>
                                        <FormUi.Field style={{ width: '12%' }} className="ml-4 mr-2 w3-tiny">
                                            <DateData
                                                name={`startDate`}
                                                autoComplete="off"
                                                popperClassName="dateTime"
                                                dateFormat={dateFormats.dd_MM_yyyy}
                                                placeholderText="From"
                                                selected={values.startDate}
                                                startDate={values.startDate}
                                                endDate={values.endDate}
                                                maxDate={values.endDate ? values.endDate : ''}
                                                selectsStart
                                                timeIntervals={5}
                                                customInput={<FormUi.Input error={values.startDate ? false : true} autoComplete="off" className="dateWidth" icon="time" iconPosition="left" />}
                                            />
                                            {touched.startDate && errors.startDate ? <strong className="w3-text-red w3-tiny font-weight-bold">{errors.startDate}</strong> : ''}
                                        </FormUi.Field>
                                        <span className="mr-2 w3-tiny">-</span>
                                        <FormUi.Field style={{ width: '12%' }} className="mr-2 w3-tiny" >
                                            <DateData
                                                name={`endDate`}
                                                autoComplete="off"
                                                popperClassName="dateTime"
                                                dateFormat={dateFormats.dd_MM_yyyy}
                                                placeholderText="To"
                                                selected={values.endDate}
                                                endDate={values.endDate}
                                                minDate={values.startDate ? values.startDate : ''}
                                                timeIntervals={5}
                                                customInput={<FormUi.Input error={values.endDate ? false : true} autoComplete="off" className="dateWidth" icon="time" iconPosition="left" />}
                                            />
                                            {touched.endDate && errors.endDate ? <strong className="w3-text-red w3-tiny font-weight-bold">{errors.endDate}</strong> : ''}
                                        </FormUi.Field>
                                        <Button disabled={isSubmitting} type="submit" onClick={handleSubmit} className="w3-tiny" circular basic size="mini" icon><Icon name="filter" color="blue" /></Button>
                                        <Button type="button" onClick={this.props.refreshDates} className="mr-4 w3-tiny" circular basic size="mini" icon><Icon name="refresh" color="grey" /></Button>
                                    </>
                                )}
                            </Formik>
                        </>
                        :
                        ""
                    }

                    <div className='filter-form'>
                        <Formik
                            enableReinitialize={true}
                            initialValues={initialFilterValues}
                            // validationSchema={validateSchema}
                            onSubmit={onSubmitFilter}
                        >
                            {({ touched, isSubmitting, errors, values, handleChange, handleSubmit, form }) => (
                                <>
                                    {/* <div style={{ display: 'flex' }}>
                                        <FormUi.Field className="ml-4 mr-2 w3-tiny">
                                            <Input
                                                type="text"
                                                placeholder="Filter Data"
                                                name="searchString"
                                                style={{
                                                    width: '250px'
                                                }}
                                                onChange={handleChange}
                                            />
                                        </FormUi.Field>
                                        <FormUi.Field className="ml-6 w3-tiny" >
                                            <DateData
                                                name={`salesDate`}
                                                autoComplete="off"
                                                popperClassName="dateTime"
                                                dateFormat={dateFormats.dd_MM_yyyy}
                                                placeholderText="Sales Date"
                                                selected={values.salesDate}
                                                minDate={values.startDate ? values.startDate : ''}
                                                timeIntervals={5}
                                                onChange={handleChange}
                                                customInput={<FormUi.Input error={values.salesDate ? false : true} autoComplete="off" className="dateWidth" icon="time" iconPosition="left" />}
                                            />
                                        </FormUi.Field>
                                        <FormUi.Field className="ml-4 w3-tiny">
                                            <Input
                                                type="text"
                                                placeholder="Lr Number"
                                                name="lrNumber"
                                                style={{
                                                    marginRight: '12px',
                                                }}
                                                onChange={handleChange}
                                            />
                                        </FormUi.Field>
                                        <FormUi.Field className="ml-6 w3-tiny" >
                                            <DateData
                                                name={`lrDate`}
                                                autoComplete="off"
                                                popperClassName="dateTime"
                                                dateFormat={dateFormats.dd_MM_yyyy}
                                                placeholderText="Lr Date"
                                                selected={values.lrDate}
                                                minDate={values.startDate ? values.startDate : ''}
                                                timeIntervals={5}
                                                onChange={handleChange}
                                                customInput={<FormUi.Input error={values.salesDate ? false : true} autoComplete="off" className="dateWidth" icon="time" iconPosition="left" />}
                                            />
                                        </FormUi.Field>
                                    </div>
                                    <br />
                                    <div style={{ display: 'flex' }}>
                                        <FormUi.Field className="ml-4 mr-2 w3-tiny">
                                            <Input
                                                type="text"
                                                placeholder="Refrence No"
                                                name="refNo"
                                                style={{
                                                    marginLeft: '-12px'
                                                }}
                                                onChange={handleChange}
                                            />
                                        </FormUi.Field>
                                        <FormUi.Field className="ml-6 w3-tiny" >
                                            <Input
                                                type="text"
                                                placeholder="Customer Name"
                                                name="customerName"
                                                onChange={handleChange}
                                            />
                                        </FormUi.Field>
                                        <Button style={{ marginLeft: '20px' }} disabled={isSubmitting} type="submit" onClick={handleSubmit} className="w3-tiny" circular basic size="mini" icon><Icon name="filter" color="blue" /></Button>

                                    </div> */}
                                    {/* <Button type="button" onClick={this.props.refreshDates} className="mr-4 w3-tiny" circular basic size="mini" icon><Icon name="refresh" color="grey" /></Button> */}
                                </>
                            )}
                        </Formik>
                    </div>
                    {
                        this.props.titleBarTitle == "Customer Invoice" || this.props.titleBarTitle == "Sales Order" ?
                            <>
                                <ClientCodeDropdown
                                    selectValue={this.props.ClientCode}
                                    getCustomerDetails={(object) =>
                                        this.setState({
                                            selectedClient: object,
                                            selectedClientChange: true
                                        })
                                    }
                                    selectOption={(code) => this.setState({ clientCode: code })}
                                />

                                <BranchCodeDropdown
                                    selectValue={this.props.BranchCode}
                                    selectedBranch={(data) =>
                                        this.setState({
                                            selectedBranch: data,
                                            selectedBranchChange: true
                                        })
                                    }
                                />
                            </>
                            : null
                    }
                    {
                        this.props.titleBarTitle == "Sales Order" ?
                            <VehicleDropdown
                                selectValue={this.props.VehicleCode}
                                selecteVehicle={(data) => {
                                    this.setState({
                                        selecteVehicle: data.value,
                                        selecteVehicleChange: true
                                    })
                                }}
                            />
                            : null
                    }
                    {
                        this.props.titleBarTitle == "Customer Invoice" || this.props.titleBarTitle == "Sales Order" ?
                            <>
                                <Input size='mini' className="mr-4 searchInput"
                                    defaultValue={this.props.searchValue}
                                    onChange={this.handleSearch}
                                    placeholder="Customized Search..." />
                            </>
                            :
                            null
                    }
                    {
                        this.props.titleBarTitle == "Customer Invoice" || this.props.titleBarTitle == "Sales Order" ?
                            <Button onClick={() => this.filterData()} size="tiny" basic color="facebook" icon style={{
                                border: '1px solid #2185d0'
                            }}>  <i className="icon"> <Icon name="filter" style={{ color: '#2185d0' }} /></i></Button>
                            : null}
                    {this.props?.customizedSearch != true && this.props.titleBarTitle != "Customer Invoice" && this.props.titleBarTitle != "Sales Order" || this.props.titleBarTitle != "Credit Note" && <Input size='mini' icon={{ name: 'search', circular: true }} onChange={this.props.handleSearch} className="mr-4 ml-4 searchInput" placeholder="Search..." />}
                    {this.props?.customizedSearch == true && this.props.titleBarTitle != "Customer Invoice" && this.props.titleBarTitle != "Sales Order" && <Input size='mini' icon={{ name: 'search', circular: true }} onKeyUp={this.props.handleSearch} className="mr-4 ml-4 searchInput"
                        defaultValue={this.props.searchValue}
                        placeholder={this.props?.searchValue?.length > 0 ? this.props.searchValue : "Customized Search..."} />
                    }
                    {
                        this.props.titleBarTitle == "Sales Order" ?
                            <Button id='exportbtn' size='tiny' onClick={this.exportDataSalesOrder} className="ml-4" basic color="facebook" icon><i className="icon"><img alt="export" src="assets/svg/export.svg" /></i> {buttons.export || "Export"}</Button>
                            : null
                    }
                    {
                        this.props.titleBarTitle == "Customer Invoice" ?
                            <Button id='exportbtn' size='tiny' onClick={this.exportDataCustomerInvoice} className="ml-4" basic color="facebook" icon><i className="icon"><img alt="export" src="assets/svg/export.svg" /></i> {buttons.export || "Export"}</Button>
                            : null
                    }
                    {
                        this.props.titleBarTitle != "Customer Invoice" && this.props.titleBarTitle != "Sales Order" && this.props.titleBarTitle != "Credit Note" ?
                            <Button size='tiny' hidden={this.props.exportHidden} onClick={this.exportDataGrid} className="ml-4" basic color="facebook" icon><i className="icon"><img alt="export" src="assets/svg/export.svg" /></i> {buttons.export || "Export"}</Button>
                            : null
                    }
                    <Button hidden={this.props.hiddenNewPopupBtn} onClick={this.props.newPopup} size='tiny' basic color="blue" icon><Icon name="plus" /> {buttons.new || "New"}</Button>
                    <Button onClick={this.handleImportOpen} hidden={this.props.hiddenImportPopupBtn} size="tiny" basic color="facebook" icon><i className="icon"><img alt="import" src={"assets/svg/import.svg"} /></i>{buttons.import || "Import"}</Button>
                </TitleBar>

                {/* <TitleBar>
                    <Grid
                        columns={4}
                        stackable
                        className="width-100cent margin-left-20"
                    >
                        <Grid.Column>
                            <label className="display-flex-center">
                                Sales No
                            </label>
                            <div className="overflow-hidden width_adjust_input_100">
                                <Input
                                    type="text"
                                    placeholder="Sales No"
                                    onChange={(e) => this.setState({ salesNo: e.target.value })}
                                // onKeyDown={(e) => {
                                //     if (e.key === 'Enter') {
                                //         searchCall()
                                //     }
                                // }}
                                />
                            </div>
                        </Grid.Column>
                        <Grid.Column>
                            <label className="display-flex-center">
                                Sales No
                            </label>
                            <div className="overflow-hidden width_adjust_input_100">
                                <Input
                                    type="text"
                                    placeholder=""
                                // onChange={(e) => setVehicleNo(e.target.value)}
                                // onKeyDown={(e) => {
                                //     if (e.key === 'Enter') {
                                //         searchCall()
                                //     }
                                // }}
                                />
                            </div>
                        </Grid.Column>
                        <Grid.Column>
                            <label className="display-flex-center">
                                Sales No
                            </label>
                            <div className="overflow-hidden width_adjust_input_100">
                                <Input
                                    type="text"
                                    placeholder=""
                                // onChange={(e) => setVehicleNo(e.target.value)}
                                // onKeyDown={(e) => {
                                //     if (e.key === 'Enter') {
                                //         searchCall()
                                //     }
                                // }}
                                />
                            </div>
                        </Grid.Column>
                        <Grid.Column>
                            <label className="display-flex-center">
                                Sales No
                            </label>
                            <div className="overflow-hidden width_adjust_input_100">
                                <Input
                                    type="text"
                                    placeholder=""
                                // onChange={(e) => setVehicleNo(e.target.value)}
                                // onKeyDown={(e) => {
                                //     if (e.key === 'Enter') {
                                //         searchCall()
                                //     }
                                // }}
                                />
                            </div>
                        </Grid.Column>
                    </Grid>
                </TitleBar> */}

                <div className="ag-theme-material agOver">
                    <AgGridReact
                        domLayout="autoHeight"
                        modules={this.state.modules}
                        sideBar={this.state.sideBar}
                        rowGroupPanelShow={"always"}
                        quickFilterText={this.props.searchValue}
                        suppressAutoSize={true}
                        columnDefs={this.props.columnDefs}
                        defaultColDef={this.state.defaultColDef}
                        frameworkComponents={this.state.frameworkComponents}
                        rowSelection="multiple"
                        noRowsOverlayComponent={this.state.noRowsOverlayComponent}
                        noRowsOverlayComponentParams={this.state.noRowsOverlayComponentParams}
                        rowData={this.unique}
                        pagination={true}
                        baseURL={this.props.baseURL}
                        suppressRowClickSelection={this.props.suppressRowSelection}
                        paginationPageSize={10}
                        onGridReady={this.onGridReady}
                        exportBtn={this.exportDataGrid}
                        onFilterChanged={this.filterChanged}
                        onRowSelected={this.props.rowSelected}
                        {...this.props}
                    />
                </div>

                <ImportModal
                    handleImportClose={this.handleImportClose}
                    openModal={this.state.ImportModalState}
                    pathName={this.props.pathName}
                    fileName={this.props.fileName}
                />

                <Modal open={this.state.openLoader} basic>
                    <div style={{ height: '150px' }}>
                        <Loader size='massive'>Preparing Files</Loader>
                    </div>
                </Modal>
            </>
        )
    };
};

export default AgGridTable;
